/* eslint-disable react-hooks/exhaustive-deps */
import {
  Form,
  Input,
  Row,
  Col,
  Card,
  Select,
  InputNumber,
  DatePicker,
  Badge,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "antd/es/form/Form";
import { useHistory } from "react-router-dom";
import { axiosInstance, BASE_API_CONFIG } from "util/Api";
import { isValidString } from "util/ApiHelper";
import Upload from "components/Upload";
import { EnquiryStatus } from "util/Constant";
import { labelComponent } from "util/UtilComponents";
import { getLabel, safeStringValue } from "../../util/ApiHelper";
import { Option } from "antd/es/mentions";
import { isManufacturer } from "../../util/helper";
import { BUSINESS_TYPE } from "../../util/Constant";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import moment from "moment";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { InfoCircleOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const ReplyWithQuotation = () => {
  const [form] = useForm();
  const history = useHistory();
  const countries = useSelector(({ common }) => common.countries);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const role = queryParams.get("role") || "general";
  const { isMobile } = useGetBreakpoints();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const id = urlParams.get("id");
  const qid = urlParams.get("qid");
  const [enquriesData, setEnquriesData] = useState(null);
  const [quotationData, setQuotationsData] = useState(null);
  const dispatch = useDispatch();
  const getEnquiryById = useCallback(
    async (id) => {
      if (isValidString(id)) {
        dispatch(fetchStart());
        try {
          const enquriesById = await axiosInstance.get(
            `${BASE_API_CONFIG.baseURL}/admin/enquiries/${id}`
          );
          setEnquriesData(enquriesById?.data?.data);
        } catch (error) {
        } finally {
          dispatch(fetchSuccess());
        }
      }
    },
    [dispatch]
  );

  const getQuotationById = useCallback(async (qid) => {
    if (isValidString(qid)) {
      const quotationResponse = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/quotations/${qid}`
      );
      setQuotationsData(quotationResponse);
    }
  }, []);

  useEffect(() => {
    getEnquiryById(id);
  }, [getEnquiryById, id]);

  useEffect(() => {
    getQuotationById(qid);
  }, [getQuotationById, qid]);


  const [fileList, setFileList] = useState([{ src: "" }]);

  const authUser = useSelector(({ auth }) => auth.userData);

  const onUpload = (data) => {
    setFileList((prevFileList) => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = data.src;
      updatedList[data.index].originalName = data?.originalName;
      return updatedList;
    });
  };
  const onRemove = (data) => {
    setFileList((prevFileList) => {
      const updatedList = [...prevFileList];
      updatedList[data.index].src = "";
      return updatedList;
    });
  };

  useEffect(() => {
    if (quotationData) {
      form.setFieldsValue({
        price: quotationData?.data?.data?.price,
        unit: quotationData?.data?.data?.units,
        responseMessage: quotationData?.data?.data?.description,
        paymentTerms: quotationData?.data?.data?.paymentTerms,
      });
      if (quotationData?.data?.data?.attachments) {
        const newFileList = quotationData?.data?.data?.attachments?.map(
          (attachment, index) => ({
            id: `image-${index + 1}`,
            src: isValidString(attachment?.src) ? attachment?.src : "",
          })
        );
        setFileList(newFileList);
      }
    }
  }, [quotationData]);

  const onSubmit = async (data) => {
    const response = await axiosInstance.post(
      `${BASE_API_CONFIG.baseURL}/admin/quotations`,  
      data
    );
    if (response.status === 200) {
      history.goBack();
    }
  };
  const onFinish = (values) => {
    let data = {
      price: values?.price,
      units: values?.unit,
      enquiryId: enquriesData?.id,
      receiverId: enquriesData?.user?.id,
      netAmount: enquriesData?.qty * values?.price,
      status: EnquiryStatus.QUOTATION_SENT,
      description: values?.responseMessage,
      currencyCode: values?.currency,
      expiryDate: values.expiryDate,
      attachments: [...fileList.filter((file) => file.src)],
    };

    onSubmit(data);
  };

  const uploadComponent = () => (
    <div className="attachments">
      <div className="sub-header"> Attachments</div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {fileList.map((file, index) => (
          <Upload
            key={index}
            index={index}
            src={file.src}
            id={index}
            label={isValidString(file?.label) ? file?.label : getLabel(index)}
            originalName={file.originalName}
            onUpload={onUpload}
            onRemove={onRemove}
          />
        ))}
      </div>
    </div>
  );

  const currency = Form.useWatch("currency", form);

  return (
    <Card className="myexim-detail-card">
      <div className="myexim-table-title">Quotation Details</div>
      <Form form={form} onFinish={onFinish} className="gx-mt-4">
        <Row gutter={16}>
          <Row gutter={16} span={24} style={{ marginLeft: 3 }}>
            <Col span={12} xs={24} sm={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label={labelComponent(
                  "Currency",
                  "Select the Quotation Currency"
                )}
                name="currency"
                rules={[
                  {
                    required: true,
                    message: "Currency is required",
                  },
                ]}
              >
                <Select showSearch size="large" placeholder="Select Currency">
                  {countries
                    ?.filter((country, index) => {
                      return (
                        index ===
                        countries.findIndex((o) => {
                          return country.currencyCode === o.currencyCode;
                        })
                      );
                    })
                    .map(
                      (option) =>
                        option.currencyCode && (
                          <Option key={option.id} value={option.currencyCode}>
                            {option.currencyCode}
                          </Option>
                        )
                    )}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label={labelComponent(
                  `Price / ${safeStringValue(
                    enquriesData?.units,
                    enquriesData?.shipmentMode === "sea"
                      ? enquriesData?.shipmentType === "fcl"
                        ? `Unit (${enquriesData?.containerType})`
                        : "Cubic Meter"
                      : "Cubic Meter"
                  )}`,
                  "Unit of Measurement displayed here is based on the Submitted Enquiry."
                )}
                name="price"
                rules={[
                  {
                    required: true,
                    message: "Price is required",
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  placeholder="Enter Price"
                  style={{ width: "100%" }}
                  addonBefore={
                    !!currency
                      ? currency
                      : isManufacturer(authUser) ||
                        role === BUSINESS_TYPE.EXPORTER
                      ? "INR"
                      : null
                  }
                />
              </Form.Item>
            </Col>

            <Col span={12} xs={24} sm={12}>
              <Form.Item
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label={labelComponent("Quotation Expiry date")}
                name="expiryDate"
                rules={[
                  {
                    required: true,
                    message: "Expiry date is required",
                  },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  disabledDate={(current) =>
                    current && current < moment().startOf("day")
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Col span={24}>
            <Form.Item
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              label={labelComponent("Response Message")}
              name="responseMessage"
              rules={[
                {
                  required: true,
                  message: "Response Message is required",
                },
              ]}
            >
              <TextArea
                showCount
                maxLength={200}
                rows={10}
                placeholder={
                  "Enter more details about the product specifications and other details which helps buyers to place the order soon"
                }
              />
            </Form.Item>
          </Col>

          <Col sm={24} md={12}>
            {uploadComponent()}
          </Col>
          <Col sm={24} md={12}>
            <div className="upload-tips gx-mt-4 gx-mb-4">
              <div className="header" style={{ display: "flex" }}>
                <InfoCircleOutlined />
                &nbsp; Tips
              </div>
              <div className="desc">
                <Badge
                  status="default"
                  text="Attach an Image / Video for reference"
                />
                <br />
                <Badge
                  status="default"
                  text="Supported file types: .jpg, .jpeg, .png, .pdf"
                />
                <br />
                <Badge status="default" text="File must not be more than 5MB" />
                <br />
                <Badge status="default" text="Ensure good quality resolution" />
                <br />
                <Badge
                  status="default"
                  text="Photo resolution must be at least 600x600"
                />
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              className="gx-text-center gx-mr-3"
              style={{
                justifyContent: isMobile ? "center" : "end",
                display: "flex",
                flex: 1,
              }}
            >
              <Button
                type="secondary"
                size="large"
                className={"submit-btn"}
                onClick={() => {
                  history.goBack();
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className={"submit-btn"}
              >
                Submit
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default ReplyWithQuotation;
